import { Helmet } from 'react-helmet-async';
// sections
import { UserListView } from 'src/sections/users';

// ----------------------------------------------------------------------

export default function UserListPage() {
  return (
    <>
      <Helmet>
        <title>Utilizadores | Fleur de Sel</title>
      </Helmet>

      <UserListView />
    </>
  );
}
